module.exports = __webpack_public_path__ + "assets/img/right_1.7c6bc5a6.png";